<mat-form-field
  matTooltipClass="error-tooltip"
  appearance="outline"
  floatLabel="always"
  [matTooltip]="errorTooltip()"
  [matTooltipDisabled]="!touched()"
  class="date-input-picker coin-form-field-outline coin-form-field-outline--{{ matFormFieldClass }} no-margin">
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <input
    #input="matInput"
    matInput
    [style.font-family]="boldValue && value ? 'Siemens Sans Bold !important' : null"
    [placeholder]="placeholder"
    [matDatepicker]="datePicker"
    [matDatepickerFilter]="dayFilter"
    [disabled]="disabled()"
    [ngModel]="value"
    [min]="min"
    [max]="max"
    (ngModelChange)="onInputChange($event)"
    (blur)="onInputBlur(input.value)" />
  <mat-icon
    aria-label="calendar-button"
    matSuffix
    (click)="$event.stopPropagation(); datePicker.open()">
    date_range
  </mat-icon>

  <mat-datepicker
    #datePicker
    (closed)="onInputBlur(input.value)"
    (opened)="insertTodayButton()"></mat-datepicker>
</mat-form-field>

<ng-template #todayButton>
  <coin-v2-button
    type="primary"
    [text]="'general.today' | translate"
    (click)="selectToday(datePicker)"></coin-v2-button>
</ng-template>
